import * as React from "react";
import { useSelector } from "react-redux";
import axios from 'axios';
import { Modal, Button } from 'react-bootstrap';
import { variables } from "../Variables";

import closeIcon from '../assets/images/cross-close.svg';
import successTick from '../assets/images/success_tick.svg';
import exclamation from '../assets/images/error_cross.svg';

import { getEstateAllEventsCount } from "../services/commonService";
import { getClientSettingsFromLocalDB } from "../services/clientLevelService";
import { EmailTempModel } from "./EmailTempModel";
const { useState, useEffect } = React;

export const EstateJobActionModel = ({ showModel, closeModel, clientId, estate, officeId }) => {

    const reduxLanguageTranslations = useSelector(state => state.selectedLanguageTranslations.selectedLanguageTranslations);
    const user = useSelector(state => state.user.user);

    const [freeSlotAction, setFreeSlotAction] = useState(true);
    const [tbcSlotAction, setTbcSlotAction] = useState(true);
    const [confirmSlotAction, setConfirmSlotAction] = useState(true);
    const [waitingListAction, setWaitingListAction] = useState(true);
    const [createConfirmEventOnCRM, setCreateConfirmEventOnCRM] = useState(true);
    const [estateEventsAllDetail, setEstateEventsAllDetail] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [submitStatus, setSubmitStatus] = useState("");
    const [confirmDisabledBtn, setConfirmDisabledBtn] = useState(false);
    const [notifyEmailToContact, setNotifyEmailToContact] = useState(false);

    const [emailScenario, setEmailScenario] = useState("");

    const [emailTempShow, setEmailTempShow] = useState(false);

    useEffect(() => {
        if (estate != null && showModel) {
            const getEstateEvents = async () => {
                setIsLoading(true);
                // const getAllEstateEvent = await getEstateAllEventsCount(estate.id, clientId);
                const getAllEstateEvent = await getEstateAllEventsCount(estate.id, clientId, "Deactivate");
                setEstateEventsAllDetail(getAllEstateEvent);

                // get client setting local db
                const getCleintSetting = await getClientSettingsFromLocalDB(user.tokenValue, officeId);

                if (getAllEstateEvent.jobScenrio.toLowerCase() == "onhold") {
                    let deserializeOnHoldProperty = JSON.parse(getCleintSetting.onholdStatusConfiguration);
                    if (deserializeOnHoldProperty != null) {
                        setNotifyEmailToContact(deserializeOnHoldProperty.notifyToWaitingList);
                    }
                } else {
                    let deserializeDeactiveProperty = JSON.parse(getCleintSetting.deactivatedStatusConfiguration);
                    if (deserializeDeactiveProperty != null) {
                        setNotifyEmailToContact(deserializeDeactiveProperty.notifyToWaitingList);
                    }
                }

                setIsLoading(false);
            }
            getEstateEvents();
        }
    }, [estate, showModel]);

    const processEntryDuringManualFlow = async () => {
        try {
            setIsLoading(true);
            let url = `${variables.API_URL}LocalEvents/ProcessEntryDuringManualFlow`;

            const jsonconfig = {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                }
            };

            const body = {
                "clientId": +clientId,
                "estateId": +estate.id,
                "freeSlotEventAction": true, //freeSlotAction, // hardcode implement "true" value  // onhold + true = waiting, onhold + false = false,
                "tbcEventAction": tbcSlotAction,
                "confirmedEventAction": estateEventsAllDetail != null && estateEventsAllDetail.cancelConfirmVisit == false ? false : confirmSlotAction,
                "waitingListAction": notifyEmailToContact  ? waitingListAction : false,
                "WaitingListOptionRemoved": estateEventsAllDetail.jobScenrio.toLowerCase() != "onhold" ? waitingListAction : false,
                "recreateConfirmedEventAction": estateEventsAllDetail != null && estateEventsAllDetail.cancelConfirmVisit && estateEventsAllDetail.recreateConfirmedEventCalActionId != null && estateEventsAllDetail.recreateConfirmedEventCalActionId != "" && confirmSlotAction ? createConfirmEventOnCRM : false
            }

            const response = await axios.post(url, body, jsonconfig);

            if (response.data) {
                if (response.data.toLowerCase() == "processed successfully") {
                    setSubmitStatus("success");
                } else if (response.data.toLowerCase() == "no entry found in table") {
                    setSubmitStatus("notfound");
                } else {
                    setSubmitStatus("error");
                }
                setIsLoading(false);
                //console.log(response.data);
            }
        } catch (error) {
            console.log(error);
            setSubmitStatus("error");
            setIsLoading(false);
        }
    }

    const closeUIModel = () => {
        setSubmitStatus("");
        setIsLoading(false);
        setEstateEventsAllDetail(null);
        setFreeSlotAction(true);
        setTbcSlotAction(true);
        setConfirmSlotAction(true);
        setWaitingListAction(true);
        setCreateConfirmEventOnCRM(true);
        closeModel(estate.id);
    }

    useEffect(() => {
        if (estateEventsAllDetail != null && estateEventsAllDetail.recreateConfirmedEventCalActionId != null && estateEventsAllDetail.recreateConfirmedEventCalActionId != "" && confirmSlotAction == false) {
            setCreateConfirmEventOnCRM(false);
        } else if (estateEventsAllDetail != null && estateEventsAllDetail.recreateConfirmedEventCalActionId != null && estateEventsAllDetail.recreateConfirmedEventCalActionId != "" && confirmSlotAction) {
            setCreateConfirmEventOnCRM(true);
        }
    }, [confirmSlotAction]);

    useEffect(() => {
        
        if (freeSlotAction == false && tbcSlotAction == false && confirmSlotAction == false && waitingListAction == false) {
            setConfirmDisabledBtn(true);
        } else {
            setConfirmDisabledBtn(false);
        }
    }, [freeSlotAction, tbcSlotAction, confirmSlotAction, waitingListAction]);

    const showEmailTemplete = (clickEmailBox) => {
        setEmailTempShow(true);

        //clickEmailBox = "pending";

        let propertyStatus = "";

        if (estateEventsAllDetail != null && estateEventsAllDetail?.jobScenrio?.toLowerCase() == "onhold") {
            propertyStatus = "OnHold_";
        } else {
            propertyStatus = "Deactive_";
        }

        setEmailScenario(`${propertyStatus}${clickEmailBox}`);
    }

    const closeEmailTemplete = () => {
        setEmailTempShow(false);
    }

    //const SCENARIOS = [
    //    { key: "OnHold_waiting", label: "Waiting + OnHold" },
    //    { key: "Deactive_waiting", label: "Waiting + Deactive" },
    //    { key: "OnHold_pending", label: "Pending + OnHold" },
    //    { key: "Deactive_pending", label: "Pending + Deactive" },
    //    { key: "OnHold_confirm", label: "Confirm + OnHold" },
    //    { key: "Deactive_confirm", label: "Confirm + Deactive" },
    //];

    return (
        <>
            <Modal show={showModel} onHide={closeUIModel} className="modalStyle p-0" size="lg">
                <Modal.Body className="p-0">
                    <div className="modal-container">
                        <div className="d-flex justify-content-between mb-4">
                            <p className="form-title">{estateEventsAllDetail != null ? estateEventsAllDetail?.jobScenrio?.toLowerCase() == "onhold" ? reduxLanguageTranslations ? reduxLanguageTranslations["actionsListOnHold"] : "Actions list On Hold" : reduxLanguageTranslations ? reduxLanguageTranslations["actionsListDeactivate"] : "Actions list Deactivate" : ""}</p>
                            <img src={closeIcon} onClick={closeUIModel} className="cursor-pointer" />
                        </div>

                        {
                            isLoading ?
                                <div className="d-flex justify-content-center align-items-center mb-2" style={{ minHeight: "25vh" }}>
                                    <div className="text-center">
                                        <div className="spinner-border text-primary mb-2" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                        <p className="mb-0">{reduxLanguageTranslations ? reduxLanguageTranslations["pleaseWaitProcessingRequest"] : "Please wait while we process your request..."}</p>
                                    </div>
                                </div>
                                : submitStatus == "" ?
                                    <div>
                                        <p className="form-title">
                                            {estateEventsAllDetail != null ? estateEventsAllDetail?.jobScenrio?.toLowerCase() == "onhold" ? reduxLanguageTranslations ? reduxLanguageTranslations["confirmStatusChangeOnHold"] : "Please confirm the change of the status to On Hold" : reduxLanguageTranslations ? reduxLanguageTranslations["confirmStatusChangeDeactivate"] : "Please confirm the change of the status to Deactivate" : ""}
                                        </p>
                                        <p className="mb-3">
                                            {reduxLanguageTranslations ? reduxLanguageTranslations["actionTriggerWarning"] : "Be aware that this action will trigger the following:"}
                                        </p>
                                        <label className="d-flex align-items-center mb-2">
                                            <input className="me-1" type="checkbox" disabled={true} checked={freeSlotAction} onChange={() => setFreeSlotAction(!freeSlotAction)} />
                                            {reduxLanguageTranslations ? reduxLanguageTranslations["deleteAllFreeSlots"] : "Delete all existing free slots"}
                                            <span className="ms-1 fw-bold">({estateEventsAllDetail != null ? estateEventsAllDetail.freeSlotCount : ""})</span>
                                        </label>
                                        <label className={`d-flex align-items-center mb-2 ${(estateEventsAllDetail != null && estateEventsAllDetail.jobScenrio.toLowerCase() == "onhold" && notifyEmailToContact) || (estateEventsAllDetail != null && estateEventsAllDetail.jobScenrio.toLowerCase() != "onhold")  ? "" : "d-none"}`}>
                                            <input className="me-1" type="checkbox" checked={waitingListAction} onChange={() => setWaitingListAction(!waitingListAction)} />
                                            {
                                                estateEventsAllDetail != null && estateEventsAllDetail?.jobScenrio?.toLowerCase() == "onhold" ?
                                                    reduxLanguageTranslations ? reduxLanguageTranslations["notifyWaitingListContacts"] : "Notify waiting list contacts"
                                                    : estateEventsAllDetail != null && estateEventsAllDetail.jobScenrio.toLowerCase() != "onhold" && notifyEmailToContact ?
                                                        reduxLanguageTranslations ? reduxLanguageTranslations["notifyWaitingListContactsRemoved"] : `Notify waiting list contacts and mark as waiting list option removed`
                                                        :
                                                        reduxLanguageTranslations ? reduxLanguageTranslations["markWaitingListOptionRemoved"] : `Mark as waiting list option removed`
                                            }
                                            <span className="ms-1 me-2 fw-bold">({estateEventsAllDetail != null ? estateEventsAllDetail.waitingListCount : ""})</span>
                                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={(e) => { e.preventDefault(); e.stopPropagation(); showEmailTemplete("waiting"); }}>
                                                <rect x="2" y="4" width="20" height="16" rx="2" stroke="currentColor" stroke-width="1.5" fill="none" />
                                                <path d="M2 7L12 13L22 7" stroke="currentColor" stroke-width="1.5" fill="none" stroke-linecap="round" stroke-linejoin="round" />
                                            </svg>
                                        </label>
                                        <label className="d-flex align-items-center mb-2">
                                            <input className="me-1" type="checkbox" checked={tbcSlotAction} onChange={() => setTbcSlotAction(!tbcSlotAction)} />
                                            {reduxLanguageTranslations ? reduxLanguageTranslations["cancelFutureTBCEvents"] : "Cancel all existing TBC events, whether future or past"}
                                            <span className="ms-1 me-2 fw-bold">({estateEventsAllDetail != null ? estateEventsAllDetail.tbcSlotCount : ""})</span>
                                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={(e) => { e.preventDefault(); e.stopPropagation(); showEmailTemplete("pending"); }}>
                                                <rect x="2" y="4" width="20" height="16" rx="2" stroke="currentColor" stroke-width="1.5" fill="none" />
                                                <path d="M2 7L12 13L22 7" stroke="currentColor" stroke-width="1.5" fill="none" stroke-linecap="round" stroke-linejoin="round" />
                                            </svg>
                                        </label>
                                        <label className="d-flex align-items-center mb-2">
                                            <input className="me-1" type="checkbox" checked={confirmSlotAction} onChange={() => setConfirmSlotAction(!confirmSlotAction)} />
                                            {
                                                estateEventsAllDetail != null && estateEventsAllDetail.cancelConfirmVisit && estateEventsAllDetail.notifyConfirmedVisitContact ?
                                                    <>
                                                        {reduxLanguageTranslations ? reduxLanguageTranslations["cancelFutureConfirmedEvents"] : "Cancel all future confirmed events"}
                                                        <span className="mx-1 fw-bold">({estateEventsAllDetail != null ? estateEventsAllDetail.confirmedSlotCount : ""})</span>
                                                        {reduxLanguageTranslations ? reduxLanguageTranslations["notifyContacts"] : "and notify contacts"}
                                                        <svg className="ms-2" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={(e) => { e.preventDefault(); e.stopPropagation(); showEmailTemplete("confirm"); }}>
                                                            <rect x="2" y="4" width="20" height="16" rx="2" stroke="currentColor" stroke-width="1.5" fill="none" />
                                                            <path d="M2 7L12 13L22 7" stroke="currentColor" stroke-width="1.5" fill="none" stroke-linecap="round" stroke-linejoin="round" />
                                                        </svg>
                                                    </>
                                                    : estateEventsAllDetail != null && estateEventsAllDetail.cancelConfirmVisit && estateEventsAllDetail.notifyConfirmedVisitContact == false ?
                                                        <>
                                                            {reduxLanguageTranslations ? reduxLanguageTranslations["cancelFutureConfirmedEvents"] : "Cancel all future confirmed events"}
                                                            <span className="mx-1 fw-bold">({estateEventsAllDetail != null ? estateEventsAllDetail.confirmedSlotCount : ""})</span>
                                                            {reduxLanguageTranslations ? reduxLanguageTranslations["noEmail"] : "(no email)"}
                                                        </>
                                                        : estateEventsAllDetail != null && estateEventsAllDetail.cancelConfirmVisit == false ?
                                                            <>
                                                                {reduxLanguageTranslations ? reduxLanguageTranslations["noActionConfirmedEvents"] : "No action on confirmed events (disabled info state)"}
                                                            </>
                                                            :
                                                            <>
                                                                {reduxLanguageTranslations ? reduxLanguageTranslations["noActionConfirmedEvents"] : "No action on confirmed events (disabled info state)"}
                                                            </>
                                            }
                                        </label>
                                        <label className={`${estateEventsAllDetail != null && estateEventsAllDetail.cancelConfirmVisit ? "" : "d-none"} d-flex align-items-center mb-3`}>
                                            <input className="me-1" type="checkbox" disabled={confirmSlotAction ? false : true} checked={createConfirmEventOnCRM} onChange={() => setCreateConfirmEventOnCRM(!createConfirmEventOnCRM)} />
                                            {
                                                estateEventsAllDetail != null && estateEventsAllDetail.recreateConfirmedEventCalActionId != null && estateEventsAllDetail.recreateConfirmedEventCalActionId != "" ?
                                                    <>
                                                        {reduxLanguageTranslations ? reduxLanguageTranslations["createWhiseCrmEvent"] : "Create events in WHISE CRM"}
                                                        <span className="ms-1 fw-bold">({estateEventsAllDetail != null ? estateEventsAllDetail.confirmedSlotCount : ""})</span>
                                                        [ {reduxLanguageTranslations ? reduxLanguageTranslations["calendarActionId"] : "Calendar Action ID:"} <span className="ms-1 fw-bold">{estateEventsAllDetail != null ? estateEventsAllDetail.recreateConfirmedEventCalActionId : ""}</span> ]
                                                    </>
                                                    :
                                                    reduxLanguageTranslations ? reduxLanguageTranslations["noCrmEventCreation"] : "No CRM event creation calendar action id is null"
                                            }
                                            {/*<span className="ms-1 fw-bold">({estateEventsAllDetail != null ? estateEventsAllDetail.recreateConfirmedEventCalActionId : ""})</span>*/}
                                        </label>
                                        <p className={`${confirmDisabledBtn == false && estateEventsAllDetail != null && estateEventsAllDetail.recreateConfirmedEventCalActionId != null && estateEventsAllDetail.recreateConfirmedEventCalActionId != "" && confirmSlotAction == false ? "mb-3 text-danger" : "d-none"}`}>{reduxLanguageTranslations ? reduxLanguageTranslations["confirmedEventsNotRecreatedWhise"] : "Since you have chosen not to delete confirmed events, these events will not be recreated in Whise CRM using the specified calendar action ID."}</p>
                                        <p className={`${confirmDisabledBtn ? "mb-3 text-danger" : "d-none"}`}>{reduxLanguageTranslations ? reduxLanguageTranslations["chooseAtLeastOne"] : "Choose at least one"}</p>
                                        <div className="d-flex justify-content-center">
                                            <button className={`${confirmDisabledBtn ? "disabled-blue-btn" : "site-btn"} site-btn-padd w-25`} onClick={processEntryDuringManualFlow} disabled={confirmDisabledBtn}>{reduxLanguageTranslations ? reduxLanguageTranslations["eventDeleteWindowModalConfirmBtn"] : "Confirm"}</button>
                                        </div>
                                    </div>
                                    :
                                    <>
                                        {
                                            submitStatus == "success" ?
                                                <>
                                                    <div className="d-flex justify-content-center">
                                                        <img src={successTick} className="mb-3" alt="success img" />
                                                    </div>
                                                    <p className="fw-bold fs-6 text-center px-3 mb-3">{reduxLanguageTranslations ? reduxLanguageTranslations["propertyStatusUpdatedSuccess"] : "Property status has been successfully updated and selected actions have been completed."}</p>
                                                    <div className="d-flex justify-content-center">
                                                        <button className="site-btn-padd close-page-btn w-25" onClick={closeUIModel}>{reduxLanguageTranslations ? reduxLanguageTranslations["close"] : "close"}</button>
                                                    </div>
                                                </>
                                                : submitStatus == "error" ?
                                                    <>
                                                        <div className="d-flex justify-content-center">
                                                            <img src={exclamation} className="mb-3" alt="error img" />
                                                        </div>
                                                        <p className="fw-bold fs-6 text-center px-3 mb-3">{reduxLanguageTranslations ? reduxLanguageTranslations["failedToProcessAction"] : "Failed to process the requested action. Please try again or contact support if the issue persists."}</p>
                                                        <div className="d-flex justify-content-center">
                                                            <button className="site-btn-padd failure-btn w-25" onClick={closeUIModel}>{reduxLanguageTranslations ? reduxLanguageTranslations["close"] : "close"}</button>
                                                        </div>
                                                    </>
                                                    :
                                                    <>
                                                        <div className="d-flex justify-content-center">
                                                            <img src={exclamation} className="mb-3" alt="error img" />
                                                        </div>
                                                        <p className="fw-bold fs-6 text-center px-3 mb-3">{reduxLanguageTranslations ? reduxLanguageTranslations["propertyNotFoundJobStatus"] : "Property is not found in the job status table database"}</p>
                                                        <div className="d-flex justify-content-center">
                                                            <button className="site-btn-padd close-page-btn w-25" onClick={closeUIModel}>{reduxLanguageTranslations ? reduxLanguageTranslations["close"] : "close"}</button>
                                                        </div>
                                                    </>
                                        }
                                    </>
                        }
                    </div>
                </Modal.Body>
            </Modal>
            <EmailTempModel show={emailTempShow} close={closeEmailTemplete} lang={"en-GB"} scenario={emailScenario} />
        </>
    )
} 
